import keys from '@debbie/common/dist/cache/keys.js';
import { getSums } from '@debbie/common/dist/economy/billing/organize.js';
import { Site } from '@debbie/common/dist/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as billingAPI from '@debbie/cortex/dist/api/billing.js';
import { billingsEntity } from '@debbie/cortex/dist/billings/index.js';
import { useCreditor } from '@debbie/cortex/dist/creditors/index.js';
import { c, h } from '@debbie/cortex/dist/index.js';
import q from '@debbie/cortex/dist/query.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import { errorNotification } from '../../utils/errors.js';
import { getBillingIdentity } from '../Billing.js';
import CreditorEconomyBillingSettings from '../economy/CreditorEconomyBillingSettings.js';
import { Col, Row } from '../Grid/index.js';
import { ArrowRight, Edit, ExternalLink, FilePlus, Send, } from '../Icons/index.js';
import { Badge, Button, CopyToClipboard, Modal, Money, PlaceholderLoader, RadioSelect, Table, } from '../index.js';
import Panel from '../Panel.js';
import ExcelPreview from './ExcelPreview.js';
import PDFPreview from './PDFPreview.js';
import UIPreview from './UIPreview.js';
var Option;
(function (Option) {
    Option["Preview"] = "Preview";
    Option["PDF"] = "PDF";
    Option["Excel"] = "Excel";
})(Option || (Option = {}));
const BillingPreview = (props) => {
    const { billing } = props;
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const creditorLoadable = useCreditor(props.billing.creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const tenant = useTenant();
    const [selectedOption, _setSelectedOption] = React.useState(localStorage.getItem('billingPreviewOption') ||
        Option.Preview);
    const [editCreditorBillingSettings, setEditCreditorBillingSettings] = React.useState(false);
    const setSelectedOption = (option) => {
        localStorage.setItem('billingPreviewOption', option);
        _setSelectedOption(option);
    };
    const invalidateBilling = () => {
        q.invalidate(keys.write.modify(billingsEntity, props.billing.billingId));
    };
    const sendBillingMutation = useMutation(async () => {
        if (!billing.billingEmailed ||
            confirm(lang.billing.billingAlreadySentAlert)) {
            await billingAPI.sendBillings([props.billing.billingId]);
        }
    }, {
        onSuccess: invalidateBilling,
        onError: (err) => {
            errorNotification(lang, err, 'any', lang.errorEntities.billing);
        },
    });
    const addToPayoutsMutation = useMutation(async () => {
        if (!billing.addedToPayouts) {
            await billingAPI.addToPayouts(props.billing.billingId);
        }
    }, {
        onSuccess: invalidateBilling,
        onError: (err) => {
            errorNotification(lang, err, 'any', lang.errorEntities.billing);
        },
    });
    const identity = getBillingIdentity(props.billing, lang);
    const sums = billing && getSums(billing);
    const balance = sums ? sums.balance : null;
    const payout = typeof balance === 'number' ? balance < 0 : null;
    return (React.createElement("div", null,
        React.createElement("div", null, billing && creditor ? (React.createElement(React.Fragment, null,
            React.createElement("h2", null,
                identity,
                " -",
                ' ',
                moment(props.billing.date).format(THEME.DATE_FORMAT_SHORT)),
            creditor && (React.createElement(Row, null,
                React.createElement(Col, { width: "6" },
                    React.createElement(SubPanel, { header: React.createElement(React.Fragment, null,
                            lang.billing.recipient,
                            React.createElement("div", { style: { float: 'right' } }, !props.billingSelector &&
                                site === Site.Caseworker && (React.createElement(Button, { size: "mini", theme: billing.billingEmailed
                                    ? 'secondary'
                                    : undefined, disabled: !(creditor.billingEmails?.to ||
                                    creditor.billingEmails?.cc ||
                                    creditor.billingEmails?.bcc), loading: sendBillingMutation.isLoading, onClick: () => sendBillingMutation.mutate() },
                                billing.billingEmailed
                                    ? lang.billing.billingSent
                                    : lang.billing.sendBilling,
                                ' ',
                                React.createElement(Send, { style: {
                                        height: '14px',
                                        width: '14px',
                                        transform: 'translateY(1px)',
                                        margin: '-0.2em 0 -0.2em 0.2em',
                                    } }))))) },
                        React.createElement(Row, null,
                            React.createElement(Col, { width: "5" },
                                React.createElement("h3", { style: { marginBottom: '0' } },
                                    creditor.name,
                                    ' ',
                                    site === Site.Caseworker && (React.createElement(ExternalLink, { style: { cursor: 'pointer' }, onClick: () => c.redirect.redirect(`/creditors/${creditor.creditorId}`) }))),
                                React.createElement("p", { style: { marginTop: '0.2em' } },
                                    React.createElement(CopyToClipboard, { text: creditor.id }, creditor.id)),
                                (creditor.settings.billingTextFieldSettings
                                    ?.underCreditorName ||
                                    tenant?.settings.billingTextFields
                                        ?.underCreditorName) && (React.createElement("p", { style: { whiteSpace: 'pre-line' } }, creditor.settings.billingTextFieldSettings
                                    ?.underCreditorName ||
                                    tenant?.settings.billingTextFields
                                        ?.underCreditorName)),
                                creditor.address?.address && (React.createElement("p", null,
                                    creditor.address.address,
                                    React.createElement("br", null),
                                    creditor.address.coAddress && (React.createElement(React.Fragment, null,
                                        creditor.address.coAddress,
                                        React.createElement("br", null))),
                                    creditor.address.zipcode,
                                    " ",
                                    creditor.address.city,
                                    React.createElement("br", null),
                                    creditor.address.country))),
                            site === Site.Caseworker && (React.createElement(Col, { width: "7" },
                                React.createElement(Emails, { type: "TO", emails: creditor.billingEmails?.to, onClick: () => setEditCreditorBillingSettings(true) }),
                                React.createElement(Emails, { type: "CC", emails: creditor.billingEmails?.cc, onClick: () => setEditCreditorBillingSettings(true) }),
                                React.createElement(Emails, { type: "BCC", emails: creditor.billingEmails?.bcc, onClick: () => setEditCreditorBillingSettings(true) }))))),
                    React.createElement(SubPanel, { header: React.createElement(React.Fragment, null,
                            lang.billing.information,
                            React.createElement("div", { style: { float: 'right' } }, !props.billingSelector &&
                                payout &&
                                site === Site.Caseworker && (React.createElement(Button, { size: "mini", theme: billing.addedToPayouts
                                    ? 'secondary'
                                    : undefined, disabled: billing.addedToPayouts ||
                                    !(creditor.bankAccountDetails
                                        ?.registrationNumber &&
                                        creditor.bankAccountDetails?.accountNumber), loading: addToPayoutsMutation.isLoading, onClick: () => addToPayoutsMutation.mutate() },
                                billing.addedToPayouts
                                    ? lang.billing.addedToPayouts
                                    : lang.billing.addToPayouts,
                                ' ',
                                React.createElement(FilePlus, { style: {
                                        height: '14px',
                                        width: '14px',
                                        transform: 'translateY(1px)',
                                        margin: '-0.2em 0 -0.2em 0.2em',
                                    } }))))) }, payout !== null &&
                        (payout ? (React.createElement(React.Fragment, null,
                            React.createElement("p", null,
                                React.createElement("b", null,
                                    React.createElement(Money, { currency: billing.currency, amount: -sums.balance })),
                                ' ',
                                lang.billing.amountWillBeWithdrawnToAccount,
                                ' ',
                                creditor.bankAccountDetails?.registrationNumber &&
                                    creditor.bankAccountDetails?.accountNumber ? (React.createElement("b", null,
                                    creditor.bankAccountDetails.registrationNumber,
                                    ' ',
                                    creditor.bankAccountDetails.accountNumber)) : ('-'),
                                ' ',
                                site === Site.Caseworker && (React.createElement(Edit, { style: { cursor: 'pointer' }, onClick: () => setEditCreditorBillingSettings(true) }))),
                            (creditor.settings.billingTextFieldSettings
                                ?.endWhenSendingPayment ||
                                tenant?.settings.billingTextFields
                                    ?.endWhenSendingPayment) && (React.createElement("p", { style: { whiteSpace: 'pre-line' } }, creditor.settings.billingTextFieldSettings
                                ?.endWhenSendingPayment ||
                                tenant?.settings.billingTextFields
                                    ?.endWhenSendingPayment)))) : (React.createElement(React.Fragment, null,
                            React.createElement("p", null,
                                React.createElement("b", null,
                                    React.createElement(Money, { currency: billing.currency, amount: sums.balance })),
                                ' ',
                                lang.billing.amountShouldBePaidToAccount,
                                ' ',
                                tenant?.bankAccountDetails?.registrationNumber &&
                                    tenant?.bankAccountDetails?.accountNumber ? (React.createElement("b", null,
                                    tenant.bankAccountDetails.registrationNumber,
                                    ' ',
                                    tenant.bankAccountDetails.accountNumber,
                                    tenant.bankAccountDetails.bankName
                                        ? ` (${tenant.bankAccountDetails.bankName})`
                                        : '')) : ('-')),
                            React.createElement("p", null,
                                lang.billing.invoiceNo,
                                " ",
                                React.createElement("b", null, billing.id || 'X'),
                                ' ',
                                lang.billing.specifiedByBankTransfer),
                            React.createElement("p", null,
                                lang.billing.paymentTerms,
                                ' ',
                                creditor.paymentTerms.paymentDays || '-',
                                ' ',
                                lang.billing.daysAndBillingDate,
                                ":",
                                ' ',
                                React.createElement("b", null, creditor.paymentTerms.paymentDays
                                    ? moment(billing.date)
                                        .add(creditor.paymentTerms.paymentDays, 'days')
                                        .format(THEME.DATE_FORMAT_SHORT)
                                    : '-')),
                            (creditor.settings.billingTextFieldSettings
                                ?.endWhenReceivingPayment ||
                                tenant?.settings.billingTextFields
                                    ?.endWhenReceivingPayment) && (React.createElement("p", { style: { whiteSpace: 'pre-line' } }, creditor.settings.billingTextFieldSettings
                                ?.endWhenReceivingPayment ||
                                tenant?.settings.billingTextFields
                                    ?.endWhenReceivingPayment))))))),
                React.createElement(Col, { width: "6" },
                    React.createElement(BillingOverview, { billing: billing })))))) : (React.createElement(PlaceholderLoader, null))),
        React.createElement("hr", null),
        React.createElement("div", null,
            React.createElement(RadioSelect, { onClick: () => setSelectedOption(Option.Preview), active: selectedOption === Option.Preview, label: lang.billing.preview }),
            React.createElement(RadioSelect, { onClick: () => setSelectedOption(Option.PDF), active: selectedOption === Option.PDF, label: lang.billing.PDFPreview }),
            React.createElement(RadioSelect, { onClick: () => setSelectedOption(Option.Excel), active: selectedOption === Option.Excel, label: lang.billing.ExcelPreview })),
        React.createElement("div", { style: { padding: `${THEME.GRID_SPACING}px 0` } }, (() => {
            switch (selectedOption) {
                case Option.Preview:
                    return (React.createElement(UIPreview, { billing: props.billing, billingSelector: props.billingSelector, closeModal: props.closeModal, highlightCaseId: props.highlightCaseId }));
                case Option.PDF:
                    return (React.createElement(PDFPreview, { billing: props.billing, billingSelector: props.billingSelector }));
                case Option.Excel:
                    return (React.createElement(ExcelPreview, { billing: props.billing, billingSelector: props.billingSelector }));
            }
        })()),
        editCreditorBillingSettings && creditor && (React.createElement(Modal, { onToggle: () => setEditCreditorBillingSettings(!editCreditorBillingSettings) },
            React.createElement(CreditorEconomyBillingSettings, { creditor: creditor })))));
};
export default BillingPreview;
const BillingOverview = (props) => {
    const lang = useSelector((s) => s.lang);
    const sums = getSums(props.billing);
    return (React.createElement("div", null,
        React.createElement(Table, { zebra: true },
            React.createElement("tr", null,
                React.createElement("th", null,
                    React.createElement(Badge, { theme: THEME.COLOR_ACCENT }, props.billing.currency)),
                React.createElement("th", { style: { textAlign: 'right' } }, lang.billing.amount),
                React.createElement("th", { style: { textAlign: 'right', width: '85px' } }, lang.billing.vat)),
            !!sums.depositSum && (React.createElement(React.Fragment, null,
                React.createElement("tr", null,
                    React.createElement("td", null, lang.billing.deposits),
                    React.createElement("td", { style: { textAlign: 'right' } },
                        React.createElement(Money, { amount: sums.depositSum })),
                    React.createElement("td", { style: { textAlign: 'right' } }, "-")),
                React.createElement("tr", { className: "sub-row" },
                    React.createElement("td", null,
                        React.createElement(ArrowRight, { style: { margin: '0.2em 0 -0.2em 0.5em' } }),
                        ' ',
                        lang.billing.forPayout),
                    React.createElement("td", { style: { textAlign: 'right' } },
                        React.createElement(Money, { amount: sums.payoutSum })),
                    React.createElement("td", { style: { textAlign: 'right' } }, "-")),
                React.createElement("tr", { className: "sub-row" },
                    React.createElement("td", null,
                        React.createElement(ArrowRight, { style: { margin: '0.2em 0 -0.2em 0.5em' } }),
                        ' ',
                        lang.billing.collectionCommission),
                    React.createElement("td", { style: { textAlign: 'right' } },
                        React.createElement(Money, { amount: sums.collectionCommissionSum })),
                    React.createElement("td", { style: { textAlign: 'right' } },
                        React.createElement(Money, { amount: sums.collectionCommissionVatSum }))),
                React.createElement("tr", { className: "sub-row" },
                    React.createElement("td", null,
                        React.createElement(ArrowRight, { style: { margin: '0.2em 0 -0.2em 0.5em' } }),
                        ' ',
                        lang.billing.overpayments),
                    React.createElement("td", { style: { textAlign: 'right' } },
                        React.createElement(Money, { amount: sums.overpaymentsSum })),
                    React.createElement("td", { style: { textAlign: 'right' } }, "-")))),
            !!(sums.feesSum + sums.feesVatSum) && (React.createElement("tr", null,
                React.createElement("td", null, lang.billing.fees),
                React.createElement("td", { style: { textAlign: 'right' } },
                    React.createElement(Money, { amount: sums.feesSum })),
                React.createElement("td", { style: { textAlign: 'right' } },
                    React.createElement(Money, { amount: sums.feesVatSum })))),
            !!(sums.disbursementsSum + sums.disbursementsVatSum) && (React.createElement("tr", null,
                React.createElement("td", null, lang.billing.disbursements),
                React.createElement("td", { style: { textAlign: 'right' } },
                    React.createElement(Money, { amount: sums.disbursementsSum })),
                React.createElement("td", { style: { textAlign: 'right' } },
                    React.createElement(Money, { amount: sums.disbursementsVatSum })))),
            !!sums.vatSum && (React.createElement("tr", null,
                React.createElement("td", null, lang.billing.otherVat),
                React.createElement("td", { style: { textAlign: 'right' } }),
                React.createElement("td", { style: { textAlign: 'right' } },
                    React.createElement(Money, { amount: sums.vatSum }))))),
        React.createElement("p", { style: { textAlign: 'right' } },
            lang.billing.subtotal,
            ": ",
            React.createElement(Money, { amount: sums.subTotal }),
            React.createElement("br", null),
            React.createElement("small", null,
                lang.billing.vat,
                ": ",
                React.createElement(Money, { amount: sums.vat })),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("b", null,
                lang.billing.total,
                ": ",
                React.createElement(Money, { amount: sums.balance })))));
};
const SubPanel = styled(Panel) `
  .header {
    color: ${THEME.COLOR_ACCENT};
  }

  > div > .body {
    background-color: #e6e6e6;
    box-shadow: none;
  }
`;
const StyledEmailsWrapper = styled.div `
  display: flex;
  justify-content: space-between;

  background-color: #f5f5f5;
  border-radius: 3px;
  margin-bottom: 0.5em;
  cursor: pointer;
  font-size: 0.8em;
`;
const StyledEmailType = styled.div `
  font-weight: bold;
  color: ${THEME.COLOR_ACCENT};
  width: 40px;
  padding: 8px 5px 8px 8px;
`;
const StyledEmails = styled.div `
  padding: 8px 5px;
  flex-grow: 1;
`;
const Emails = (props) => {
    return (React.createElement(StyledEmailsWrapper, { onClick: props.onClick },
        React.createElement(StyledEmailType, null, props.type),
        React.createElement(StyledEmails, null, props.emails || '-'),
        React.createElement(Edit, { style: {
                margin: '9px',
            } })));
};
//# sourceMappingURL=BillingPreview.js.map